import Select from "react-select";
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Disclosure } from "@headlessui/react";
import SharesAndBonds from "./SharesAndBonds";
import { Loader } from "../utils";
import SharedModal from "../happiness/SharedModal";
import AddLocation from "./AddLocation";
import { UploadCourtDocument, getsub_categories } from "../../services/Common";

const DisclosureSection = ({
  disclosure,
  index,
  disclosureRefs,
  disclosures,
  lastDisclosureRef,
  seperateRequests,
  openDisclosures,
  parentDisclosureRef,
  openDeleteModal,
  removeDisclosure,
  displayIndexMap,
  setOpenDisclosures,
  isLoading,
  isRtl,
  isSearchable,
  CustomDropdownIndicator,
  customTheme,
  customStyles,
  serviceCaregories,
  setSeperateRequests,
  clearErrors,
  handleOrderTypeChange,
  states,
  getClassificationStyles,
  disabledClassifications,
  formatOptionLabel,
  handleSubOrderTypeChange,
  catigories,
  handleClassificationChange,
  classificationOptions,
  setClassificationOptions,
  setDismissedTooltips,
  setDismissedSharesAndBonds,
  suborderTypeOptions,
  keyValue,
  isChecked,
  handleCheckboxChange,
  InquiryOptions,
  handleInquiryOptionChange,
  resetDisclosureFields,
  sharedValues,
  setSharedValues,
  dismissedTooltips,
  uploadingDisclosures,
  dismissedSharesAndBonds,
  previewDisclosureId,
  resetDisclosureCustomFields,

  register,
  setShowMap,
  handleLocationSelect,
  openMapForDisclosure,
  setValue,
  getValues,
  setError,
  isMobileDevice,
  setDisplayedImage,
  setPreviewDisclosureId,
  setShowImage,
  showImage,
  displayedImage,
  navigate,
  handleFileChange,
  enPhrase,
  arPhrase,
  disclosureData,
  lang,
  control,
  errors,
  setDisclosureData,
  setIsSubmitting,
  setIsSubmittingDocuments,
  disabledSuborderTypes,
  loadingClassifications,
  loadingSuborderTypes,
}) => {
  console.log("NewdisclosureData", disclosureData);

  const [uploadingIdentification, setUploadingIdentification] = useState({});

  const handleIdentificationUpload = async (disclosureId, files, field) => {
    setIsSubmittingDocuments((prev) => ({ ...prev, [disclosureId]: true }));
    setUploadingIdentification((prev) => ({ ...prev, [disclosureId]: true }));

    try {
      const uploadedHashes = [];

      for (let file of files) {
        const res = await UploadCourtDocument(file);
        if (res?.hash) {
          uploadedHashes.push(res.hash);
        }
      }

      // Only if successful uploads exist
      if (uploadedHashes.length > 0) {
        setDisclosureData((prev) => {
          const updated = { ...prev };
          const prevDocs = updated[disclosureId]?.SubjectDocuments || [];
          const prevFiles =
            updated[disclosureId]?.fileIdentificationUpload || [];

          // Combine and limit
          const newDocs = [...prevDocs, ...uploadedHashes].slice(0, 7);
          const newFiles = [...prevFiles, ...files].slice(0, 7);

          updated[disclosureId] = {
            ...updated[disclosureId],
            SubjectDocuments: newDocs,
            fileIdentificationUpload: newFiles,
          };

          // Also update copy
          const cloneId = `${disclosureId}-copy`;
          if (updated[cloneId]) {
            const cloneDocs = updated[cloneId]?.SubjectDocuments || [];
            const cloneFiles = updated[cloneId]?.fileIdentificationUpload || [];

            updated[cloneId] = {
              ...updated[cloneId],
              SubjectDocuments: [...cloneDocs, ...uploadedHashes].slice(0, 7),
              fileIdentificationUpload: [...cloneFiles, ...files].slice(0, 7),
            };
          }

          return updated;
        });

        // Update react-hook-form
        field.onChange(files);
      }
    } catch (error) {
      console.error("Error uploading identification files:", error);
      setError(`fileidentificationupload-${disclosureId}`, {
        type: "manual",
        message:
          lang === "en"
            ? "Something went wrong. Please try again later"
            : "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا",
      });
    } finally {
      setIsSubmittingDocuments((prev) => ({ ...prev, [disclosureId]: false }));
      setUploadingIdentification((prev) => ({
        ...prev,
        [disclosureId]: false,
      }));
    }
  };

  return (
    <Disclosure
      key={disclosure.id}
      as="div"
      className={`w-full  bg-[#A9803114] border-[0.5px] border-[#EEE2D0]  shadow-[0px_10px_40px_#361E1214] rounded-[16px]  flex flex-col items-center gap-[24px]`}
      defaultOpen={true}
      ref={(el) => {
        // Store in disclosureRefs
        if (el) {
          disclosureRefs.current[disclosure.id] = el;
        }
        // Assign to lastDisclosureRef if it's the last one
        if (index === disclosures.length - 1) {
          if (lastDisclosureRef) {
            lastDisclosureRef.current = el;
          } else if (parentDisclosureRef) {
            parentDisclosureRef.current = el;
          }
        }
      }}
    >
      {() => {
        const isopen = openDisclosures[disclosure?.id];

        return (
          <div
            className={`w-full bg-[#A9803114] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] flex flex-col items-center gap-[24px]`}
          >
            <Disclosure.Button
              className={`group flex w-full items-center justify-between px-[20px]  ${
                !isopen ? "h-[52px]" : "pt-[16px] "
              } ${
                !isopen && seperateRequests[disclosure.id]
                  ? "h-auto md:h-[72px]"
                  : ""
              }`}
              onClick={() =>
                setOpenDisclosures((prev) => ({
                  ...prev,
                  [disclosure.id]: !prev[disclosure.id],
                }))
              }
            >
              <div
                className={`${
                  seperateRequests[disclosure.id]
                    ? "flex flex-col gap-[12px] py-[5px]"
                    : ""
                }`}
              >
                <div className="flex flex-row items-center gap-[16px]">
                  <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                    {/* {displayIndexMap[disclosure.id]} */}
                    {displayIndexMap?.[disclosure?.id] || ""}
                  </p>
                  <div
                    className={`flex  items-start ${
                      seperateRequests[disclosure.id]
                        ? "flex-col gap-[4px] md:flex-row md:gap-[16px]"
                        : "flex-col"
                    }`}
                  >
                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                      {lang === "en"
                        ? enPhrase["lblRequestDetail"]
                        : arPhrase["lblRequestDetail"]}
                    </p>
                    {seperateRequests[disclosure.id] && (
                      <div className="flex flex-row gap-[16px]">
                        <img
                          src="/assets/img/add-request/building.svg"
                          alt=""
                          className=""
                        />
                        <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#D1AB62]">
                          {lang === "en"
                            ? enPhrase["lblAddressedToDFM"]
                            : arPhrase["lblAddressedToDFM"]}
                        </p>
                      </div>
                    )}

                    {!isopen &&
                    disclosureData[disclosure.id]?.orderType?.name &&
                    disclosureData[disclosure.id]?.classificationType ? (
                      <div className="flex flex-row items-center gap-[5px]">
                        <p className="font-Almarai font-400 text-[11px] leading-[16px] text-[#6F6A62]">
                          {disclosureData[disclosure.id]?.orderType?.name}
                        </p>
                        <span>•</span>
                        <p className="font-Almarai font-400 text-[11px] leading-[16px] text-[#6F6A62]">
                          {
                            disclosureData[disclosure.id]?.classificationType
                              ?.name
                          }
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {seperateRequests[disclosure.id] && (
                  <img
                    src="/assets/img/add-request/seperatedLine.svg"
                    alt="line"
                    className="w-[260px] md:w-full"
                  />
                )}
                {seperateRequests[disclosure.id] ? (
                  <div className="flex flex-row items-center gap-[16px]">
                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                      {" "}
                      {/* {index + 2} */}
                      {displayIndexMap[`${disclosure.id}-copy`]}
                    </p>
                    <div className="flex flex-col gap-[4px] md:gap-[16px] md:flex-row">
                      <div className="flex flex-col md:flex-row md:gap-[16px] items-start">
                        <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                          {lang === "en"
                            ? enPhrase["lblRequestDetail"]
                            : arPhrase["lblRequestDetail"]}
                        </p>
                        <div className="flex flex-row gap-[16px]">
                          <img
                            src="/assets/img/add-request/building.svg"
                            alt=""
                            className=""
                          />
                          <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#D1AB62]">
                            {lang === "en"
                              ? enPhrase["lblADX"]
                              : arPhrase["lblADX"]}
                          </p>
                        </div>
                      </div>
                      {!isopen &&
                      disclosureData[disclosure.id]?.orderType?.name &&
                      disclosureData[disclosure.id]?.classificationType ? (
                        <div className="flex flex-row items-center gap-[5px]">
                          <p className="font-Almarai font-400 text-[11px] leading-[16px] text-[#6F6A62]">
                            {disclosureData[disclosure.id]?.orderType?.name}
                          </p>
                          <span>•</span>
                          <p className="font-Almarai font-400 text-[11px] leading-[16px] text-[#6F6A62]">
                            {
                              disclosureData[disclosure.id]?.classificationType
                                ?.name
                            }
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="flex flex-row gap-[10px] items-center">
                {disclosures.length > 1 && (
                  <img
                    className={`size-5 fill-white/60 transition-transform duration-300 ease-out group-hover:fill-white/50 ${
                      isopen ? "" : ""
                    }`}
                    src="/assets/img/add-request/delete.svg"
                    alt=""
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent disclosure toggle
                      const data = disclosureData[disclosure.id];
                      const isEmpty =
                        !data?.orderType &&
                        !data?.classificationType &&
                        !data?.suborderType &&
                        !data?.inquiryOption &&
                        !data?.fileUpload;

                      if (isEmpty) {
                        removeDisclosure(disclosure.id);
                      } else {
                        openDeleteModal(disclosure.id);
                      }
                    }}
                  />
                )}

                <img
                  src="/assets/img/add-request/dash.svg"
                  alt="dash"
                  className="w-[1px] h-[20px]"
                />
                <img
                  className={`size-5 fill-white/60 transition-transform duration-300 ease-out group-hover:fill-white/50 ${
                    isopen ? "" : "rotate-180"
                  }`}
                  src="/assets/img/add-request/ArrowUP.svg"
                  alt=""
                />
              </div>
            </Disclosure.Button>
            <Disclosure.Panel
              static
              className={`w-[99%] rounded-[12px] border-[0.5px] border-solid border-[#D4D2CE] bg-[#fff] shadow-[0px_10px_40px_#351F131F] p-[16px] gap-[16px] flex flex-col transition-all duration-500 ease-in-out overflow-visible ${
                isopen
                  ? "relative visible max-h-auto opacity-100 mb-[4px]"
                  : "absolute hidden max-h-0 opacity-0"
              }`}
            >
              <div className="w-full flex flex-col gap-[16px]">
                <div className="flex flex-col md:flex-row items-stretch justify-between w-full gap-[16px]">
                  <div className="w-full md:w-1/2">
                    <label
                      htmlFor="orderType"
                      className={`block text-[12px]  ${
                        errors[`orderType-${disclosure.id}`]
                          ? "text-[#E61A05] font-normal"
                          : "text-gray-700 font-bold"
                      }`}
                    >
                      {lang === "en"
                        ? enPhrase["lblRequest"]
                        : arPhrase["lblRequest"]}
                    </label>
                    <Controller
                      //   name="orderType"
                      name={`orderType-${disclosure.id}`}
                      rules={{
                        required: "Order Types is required",
                        // onChange: ChangeMainCategoery,
                      }}
                      control={control}
                      render={({ field }) => (
                        <Select
                          components={{
                            DropdownIndicator: CustomDropdownIndicator,
                          }}
                          // isDisabled={serviceCaregories.length === 0}
                          isDisabled={
                            !sharedValues?.court?.id ||
                            serviceCaregories.length === 0
                          }
                          theme={customTheme}
                          styles={customStyles}
                          noOptionsMessage={() =>
                            lang === "en"
                              ? enPhrase["lblNoResultFound"]
                              : arPhrase["lblNoResultFound"]
                          }
                          placeholder={
                            <div className="text-gray-600 text-sm">
                              {lang === "en"
                                ? enPhrase["lblRequestHolder"]
                                : arPhrase["lblRequestHolder"]}
                            </div>
                          }
                          label="orderType"
                          error={false}
                          {...field}
                          classNames={{
                            control: () =>
                              `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                                errors[`orderType-${disclosure.id}`]
                                  ? "!border-red-600"
                                  : "!border-gray-300"
                              }`,
                          }}
                          classNamePrefix="select"
                          //   value={defaultOption || selectedorderType}

                          value={
                            disclosureData[disclosure.id]?.orderType ||
                            field.value
                          }
                          onChange={async (selected) => {
                            field.onChange(selected);
                            handleOrderTypeChange(disclosure.id, selected);
                            clearErrors(`orderType-${disclosure.id}`); // ✅ Clears error
                            // 🚨 Reset cloned disclosure if it exists
                            const syntheticId = `${disclosure.id}-copy`;
                            setDisclosureData((prevData) => {
                              if (prevData[syntheticId]) {
                                const updated = { ...prevData };
                                delete updated[syntheticId];
                                return updated;
                              }
                              return prevData;
                            });

                            // Also reset separate request flag if needed
                            setSeperateRequests((prev) => {
                              const updated = { ...prev };
                              delete updated[disclosure.id];
                              return updated;
                            });
                          }}
                          isLoading={isLoading}
                          // isClearable={isClearable}
                          isRtl={isRtl}
                          isSearchable={isSearchable}
                          options={serviceCaregories}
                          getOptionLabel={(options) => options["name"]}
                          getOptionValue={(options) => options["id"]}
                          formatOptionLabel={formatOptionLabel}
                        />
                      )}
                    />

                    {errors[`orderType-${disclosure.id}`] && (
                      <span role="alert" className=" text-xs text-red-600">
                        {lang === "en"
                          ? enPhrase["drpdwn_ApplicationType_error"]
                          : arPhrase["drpdwn_ApplicationType_error"]}
                      </span>
                    )}
                  </div>

                  {/* <div className="w-full md:w-1/2">
                    <label
                      htmlFor="classificationType"
                      className={`block text-[12px]  ${
                        errors[`classificationType-${disclosure.id}`]
                          ? "text-[#E61A05] font-normal"
                          : "text-gray-700 font-bold"
                      }`}
                    >
                      {lang === "en"
                        ? enPhrase["lblCategory"]
                        : arPhrase["lblCategory"]}
                    </label>

                    <Controller
                      name={`classificationType-${disclosure.id}`}
                      rules={{
                        required: disabledClassifications[disclosure.id]
                          ? false
                          : "Classification Type is required",
                      }}
                      control={control}
                      render={({ field }) => {
                        const isDisabled =
                          disabledClassifications[disclosure.id];
                        const selected =
                          disclosureData[disclosure.id]?.classificationType;
                        const currentOptions = Array.isArray(
                          classificationOptions[disclosure.id]
                        )
                          ? classificationOptions[disclosure.id]
                          : [];

                        return (
                          <div
                            className="relative"
                            title={isDisabled && selected ? selected.name : ""}
                          >
                            <Select
                              components={{
                                DropdownIndicator: CustomDropdownIndicator,
                              }}
                              theme={customTheme}
                              styles={getClassificationStyles(isDisabled)}
                              noOptionsMessage={() =>
                                lang === "en"
                                  ? enPhrase["lblNoResultFound"]
                                  : arPhrase["lblNoResultFound"]
                              }
                              placeholder={
                                <div
                                  className={`${
                                    isDisabled
                                      ? "!text-[#838383]"
                                      : "text-gray-600"
                                  } text-sm`}
                                >
                                  {lang === "en"
                                    ? enPhrase["lblCategoryHolder"]
                                    : arPhrase["lblCategoryHolder"]}
                                </div>
                              }
                              label="classificationType"
                              error={false}
                              {...field}
                              classNames={{
                                control: () =>
                                  `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                                    errors[
                                      `classificationType-${disclosure.id}`
                                    ]
                                      ? "!border-red-600"
                                      : "!border-gray-300"
                                  }`,
                              }}
                              classNamePrefix="select"
                              defaultValue={states[0]}
                              isDisabled={isDisabled}
                              isLoading={isLoading}
                              isRtl={isRtl}
                              isSearchable={isSearchable}
                              // options={
                              //   classificationOptions[disclosure.id] || states
                              // }
                              options={currentOptions}
                              value={selected || null}
                              onChange={(selected) => {
                                field.onChange(selected);
                                handleClassificationChange(
                                  disclosure.id,
                                  selected
                                );
                                clearErrors(
                                  `classificationType-${disclosure.id}`
                                );
                              }}
                              getOptionLabel={(options) => options["name"]}
                              getOptionValue={(options) => options["id"]}
                              formatOptionLabel={formatOptionLabel}
                            />
                          </div>
                        );
                      }}
                    />

                    {errors[`classificationType-${disclosure.id}`] && (
                      <span role="alert" className=" text-xs text-red-600">
                        {lang === "en"
                          ? enPhrase["lblCategoryError"]
                          : arPhrase["lblCategoryError"]}
                      </span>
                    )}
                  </div> */}

                  <div className="w-full md:w-1/2">
                    <label
                      htmlFor="classificationType"
                      className={`block text-[12px]  ${
                        errors[`classificationType-${disclosure.id}`]
                          ? "text-[#E61A05] font-normal"
                          : "text-gray-700 font-bold"
                      }`}
                    >
                      {lang === "en"
                        ? enPhrase["lblCategory"]
                        : arPhrase["lblCategory"]}
                    </label>

                    <Controller
                      name={`classificationType-${disclosure.id}`}
                      control={control}
                      rules={{
                        validate: (v) => {
                          const hasOrderType =
                            !!disclosureData?.[disclosure.id]?.orderType;
                          const optionsCount = Array.isArray(
                            classificationOptions?.[disclosure.id]
                          )
                            ? classificationOptions[disclosure.id].length
                            : 0;

                          const disabled =
                            !sharedValues?.court?.id ||
                            !hasOrderType ||
                            !!loadingClassifications?.[disclosure.id] ||
                            optionsCount === 0 ||
                            !!disabledClassifications?.[disclosure.id];

                          if (disabled) return true;

                          return v
                            ? true
                            : lang === "en"
                            ? enPhrase["lblCategoryError"]
                            : arPhrase["lblCategoryError"];
                        },
                      }}
                      render={({ field }) => {
                        const hasOrderType =
                          !!disclosureData?.[disclosure.id]?.orderType;

                        const currentOptions = Array.isArray(
                          classificationOptions?.[disclosure.id]
                        )
                          ? classificationOptions[disclosure.id]
                          : [];

                        const selected =
                          disclosureData?.[disclosure.id]?.classificationType ||
                          null;

                        const isBusy =
                          !!loadingClassifications?.[disclosure.id];

                        const lockedByAutoSelect =
                          !!disabledClassifications?.[disclosure.id];

                        const shouldDisableClassification =
                          !sharedValues?.court?.id ||
                          !hasOrderType ||
                          isBusy ||
                          currentOptions.length === 0 ||
                          lockedByAutoSelect;

                        return (
                          <div
                            className="relative"
                            title={
                              shouldDisableClassification && selected
                                ? selected.name
                                : ""
                            }
                          >
                            <Select
                              components={{
                                DropdownIndicator: CustomDropdownIndicator,
                              }}
                              theme={customTheme}
                              styles={getClassificationStyles(
                                shouldDisableClassification
                              )}
                              noOptionsMessage={() =>
                                lang === "en"
                                  ? enPhrase["lblNoResultFound"]
                                  : arPhrase["lblNoResultFound"]
                              }
                              placeholder={
                                <div
                                  className={`${
                                    shouldDisableClassification
                                      ? "!text-[#838383]"
                                      : "text-gray-600"
                                  } text-sm`}
                                >
                                  {lang === "en"
                                    ? enPhrase["lblCategoryHolder"]
                                    : arPhrase["lblCategoryHolder"]}
                                </div>
                              }
                              label="classificationType"
                              error={false}
                              {...field}
                              classNames={{
                                control: () =>
                                  `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                                    errors[
                                      `classificationType-${disclosure.id}`
                                    ]
                                      ? "!border-red-600"
                                      : "!border-gray-300"
                                  }`,
                              }}
                              classNamePrefix="select"
                              isDisabled={shouldDisableClassification}
                              isLoading={isLoading || isBusy}
                              isRtl={isRtl}
                              isSearchable={isSearchable}
                              options={currentOptions}
                              value={selected}
                              onChange={(selected) => {
                                field.onChange(selected);
                                handleClassificationChange(
                                  disclosure.id,
                                  selected
                                );
                                clearErrors(
                                  `classificationType-${disclosure.id}`
                                );
                              }}
                              getOptionLabel={(o) => o["name"]}
                              getOptionValue={(o) => o["id"]}
                              formatOptionLabel={formatOptionLabel}
                            />
                          </div>
                        );
                      }}
                    />

                    {errors[`classificationType-${disclosure.id}`] && (
                      <span role="alert" className=" text-xs text-red-600">
                        {lang === "en"
                          ? enPhrase["lblCategoryError"]
                          : arPhrase["lblCategoryError"]}
                      </span>
                    )}
                  </div>
                </div>

                <div className="w-full border-[0.5px]  border-[#E6E6E6]"></div>

                <div className="border-[0.5px] border-solid border-[#D4D2CE] rounded-[8px] bg-[#A980310A]  ">
                  <div className=" bg-[#eee2d0] w-full rounded-t-[8px]">
                    <div className="h-[36px] w-full flex items-center px-[24px] justify-between">
                      <span className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
                        {lang === "en"
                          ? enPhrase["lblServiceDetails"]
                          : arPhrase["lblServiceDetails"]}
                      </span>
                    </div>
                  </div>
                  <div className="p-[16px] gap-[16px] flex flex-col">
                    <div className="flex flex-col md:flex-row items-stretch justify-between w-full gap-[16px]">
                      {/* <div className="w-full md:w-1/2">
                        <label
                          htmlFor="suborderType"
                          className={`block text-[12px]  ${
                            errors[`suborderType-${disclosure.id}`]
                              ? "text-[#E61A05] font-normal"
                              : "text-gray-700 font-bold"
                          }`}
                        >
                          {lang === "en"
                            ? enPhrase["lblServiceType"]
                            : arPhrase["lblServiceType"]}
                        </label>

                        <Controller
                          name={`suborderType-${disclosure.id}`}
                          rules={{
                            required: "Sub Classification Type is required",
                          }}
                          control={control}
                          render={({ field }) => {
                            // 1. Extract the values needed for the title
                            const isDisabled =
                              !!disabledSuborderTypes[disclosure.id];
                            const selected =
                              disclosureData[disclosure.id]?.suborderType;

                            return (
                              // 2. Wrap the Select in a div with the title attribute
                              <div
                                className="relative"
                                title={
                                  isDisabled && selected ? selected.name : ""
                                }
                              >
                                <Select
                                  components={{
                                    DropdownIndicator: CustomDropdownIndicator,
                                  }}
                                  theme={customTheme}
                                  styles={customStyles}
                                  noOptionsMessage={() =>
                                    lang === "en"
                                      ? enPhrase["lblNoResultFound"]
                                      : arPhrase["lblNoResultFound"]
                                  }
                                  placeholder={
                                    <div className="text-gray-600 text-sm">
                                      {lang === "en"
                                        ? enPhrase["lblServiceTypeHolder"]
                                        : arPhrase["lblServiceTypeHolder"]}
                                    </div>
                                  }
                                  label="suborderType"
                                  error={false}
                                  {...field}
                                  classNames={{
                                    control: () =>
                                      `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                                        errors[`suborderType-${disclosure.id}`]
                                          ? "!border-red-600"
                                          : "!border-gray-300"
                                      }`,
                                  }}
                                  classNamePrefix="select"
                                  defaultValue={catigories[0]}
                                  isDisabled={isDisabled}
                                  isLoading={isLoading}
                                  isRtl={isRtl}
                                  isSearchable={isSearchable}
                                  value={selected || null}
                                  onChange={(selected) => {
                                    field.onChange(selected);
                                    handleSubOrderTypeChange(
                                      disclosure.id,
                                      selected
                                    );
                                    clearErrors(
                                      `suborderType-${disclosure.id}`
                                    );

                                    setDismissedTooltips((prev) => ({
                                      ...prev,
                                      [disclosure.id]: false,
                                    }));
                                    setDismissedSharesAndBonds((prev) => ({
                                      ...prev,
                                      [disclosure.id]: false,
                                    }));

                                    const syntheticId = `${disclosure.id}-copy`;
                                    setDisclosureData((prevData) => {
                                      const updated = { ...prevData };
                                      if (updated[syntheticId]) {
                                        delete updated[syntheticId];
                                      }
                                      return updated;
                                    });

                                    setSeperateRequests((prev) => {
                                      const updated = { ...prev };
                                      if (updated[disclosure.id]) {
                                        delete updated[disclosure.id];
                                      }
                                      return updated;
                                    });
                                  }}
                                  options={
                                    Array.isArray(
                                      suborderTypeOptions[disclosure.id]
                                    )
                                      ? suborderTypeOptions[disclosure.id]
                                      : []
                                  }
                                  getOptionLabel={(options) => options["name"]}
                                  getOptionValue={(options) => options["id"]}
                                  formatOptionLabel={formatOptionLabel}
                                />
                              </div>
                            );
                          }}
                        />

                        {keyValue.length > 0 && (
                          <label className="flex items-center justify-start gap-[8px] mt-[8px]">
                            <input
                              type="checkbox"
                              className="text-[#AF8C45] border-[#AF8C45] focus:border-gold-100 focus:ring-gold-100 rounded-[4px]"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                            <p className="text-[14px] font-Almarai text-[#AF8C45] ">
                              {lang === "en"
                                ? enPhrase["lblKeysChanges"]
                                : arPhrase["lblKeysChanges"]}
                            </p>
                          </label>
                        )}

                        {errors[`suborderType-${disclosure.id}`] && (
                          <span role="alert" className=" text-xs text-red-600">
                            {lang === "en"
                              ? enPhrase["lblServiceError"]
                              : arPhrase["lblServiceError"]}
                          </span>
                        )}
                      </div> */}

                      <div className="w-full md:w-1/2">
                        <label
                          htmlFor="suborderType"
                          className={`block text-[12px]  ${
                            errors[`suborderType-${disclosure.id}`]
                              ? "text-[#E61A05] font-normal"
                              : "text-gray-700 font-bold"
                          }`}
                        >
                          {lang === "en"
                            ? enPhrase["lblServiceType"]
                            : arPhrase["lblServiceType"]}
                        </label>

                        <Controller
                          name={`suborderType-${disclosure.id}`}
                          control={control}
                          rules={{
                            validate: (v) => {
                              const hasCourt = !!sharedValues?.court?.id;
                              const hasOrderType =
                                !!disclosureData?.[disclosure.id]?.orderType;
                              const hasClassification =
                                !!disclosureData?.[disclosure.id]
                                  ?.classificationType;

                              const optionsCount = Array.isArray(
                                suborderTypeOptions?.[disclosure.id]
                              )
                                ? suborderTypeOptions[disclosure.id].length
                                : 0;

                              const disabled =
                                !hasCourt ||
                                !hasOrderType ||
                                !hasClassification ||
                                !!loadingSuborderTypes?.[disclosure.id] ||
                                optionsCount === 0 ||
                                !!disabledSuborderTypes?.[disclosure.id];

                              if (disabled) return true;

                              return v
                                ? true
                                : lang === "en"
                                ? enPhrase["lblServiceError"]
                                : arPhrase["lblServiceError"];
                            },
                          }}
                          render={({ field }) => {
                            const hasCourt = !!sharedValues?.court?.id;
                            const hasOrderType =
                              !!disclosureData?.[disclosure.id]?.orderType;
                            const hasClassification =
                              !!disclosureData?.[disclosure.id]
                                ?.classificationType;

                            const currentOptions = Array.isArray(
                              suborderTypeOptions?.[disclosure.id]
                            )
                              ? suborderTypeOptions[disclosure.id]
                              : [];

                            const selected =
                              disclosureData?.[disclosure.id]?.suborderType ||
                              null;

                            const isBusy =
                              !!loadingSuborderTypes?.[disclosure.id];

                            const lockedByAutoSelect =
                              !!disabledSuborderTypes?.[disclosure.id];

                            const shouldDisableSuborderType =
                              !hasCourt ||
                              !hasOrderType ||
                              !hasClassification ||
                              isBusy ||
                              currentOptions.length === 0 ||
                              lockedByAutoSelect;

                            return (
                              <div
                                className="relative"
                                title={
                                  shouldDisableSuborderType && selected
                                    ? selected.name
                                    : ""
                                }
                              >
                                <Select
                                  components={{
                                    DropdownIndicator: CustomDropdownIndicator,
                                  }}
                                  theme={customTheme}
                                  styles={customStyles}
                                  noOptionsMessage={() =>
                                    lang === "en"
                                      ? enPhrase["lblNoResultFound"]
                                      : arPhrase["lblNoResultFound"]
                                  }
                                  placeholder={
                                    <div
                                      className={`${
                                        shouldDisableSuborderType
                                          ? "!text-[#838383]"
                                          : "text-gray-600"
                                      } text-sm`}
                                    >
                                      {lang === "en"
                                        ? enPhrase["lblServiceTypeHolder"]
                                        : arPhrase["lblServiceTypeHolder"]}
                                    </div>
                                  }
                                  label="suborderType"
                                  error={false}
                                  {...field}
                                  classNames={{
                                    control: () =>
                                      `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                                        errors[`suborderType-${disclosure.id}`]
                                          ? "!border-red-600"
                                          : "!border-gray-300"
                                      }`,
                                  }}
                                  classNamePrefix="select"
                                  isDisabled={shouldDisableSuborderType}
                                  isLoading={isLoading || isBusy}
                                  isRtl={isRtl}
                                  isSearchable={isSearchable}
                                  options={currentOptions}
                                  value={selected}
                                  onChange={(selected) => {
                                    field.onChange(selected);
                                    handleSubOrderTypeChange(
                                      disclosure.id,
                                      selected
                                    );
                                    clearErrors(
                                      `suborderType-${disclosure.id}`
                                    );

                                    setDismissedTooltips((prev) => ({
                                      ...prev,
                                      [disclosure.id]: false,
                                    }));
                                    setDismissedSharesAndBonds((prev) => ({
                                      ...prev,
                                      [disclosure.id]: false,
                                    }));

                                    const syntheticId = `${disclosure.id}-copy`;
                                    setDisclosureData((prevData) => {
                                      const updated = { ...prevData };
                                      if (updated[syntheticId])
                                        delete updated[syntheticId];
                                      return updated;
                                    });

                                    setSeperateRequests((prev) => {
                                      const updated = { ...prev };
                                      if (updated[disclosure.id])
                                        delete updated[disclosure.id];
                                      return updated;
                                    });
                                  }}
                                  getOptionLabel={(o) => o["name"]}
                                  getOptionValue={(o) => o["id"]}
                                  formatOptionLabel={formatOptionLabel}
                                />
                              </div>
                            );
                          }}
                        />

                        {keyValue.length > 0 && (
                          <label className="flex items-center justify-start gap-[8px] mt-[8px]">
                            <input
                              type="checkbox"
                              className="text-[#AF8C45] border-[#AF8C45] focus:border-gold-100 focus:ring-gold-100 rounded-[4px]"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                            <p className="text-[14px] font-Almarai text-[#AF8C45] ">
                              {lang === "en"
                                ? enPhrase["lblKeysChanges"]
                                : arPhrase["lblKeysChanges"]}
                            </p>
                          </label>
                        )}

                        {errors[`suborderType-${disclosure.id}`] && (
                          <span role="alert" className=" text-xs text-red-600">
                            {lang === "en"
                              ? enPhrase["lblServiceError"]
                              : arPhrase["lblServiceError"]}
                          </span>
                        )}
                      </div>

                      <div className="w-full md:w-1/2">
                        <div>
                          <label
                            htmlFor="InquiryOption"
                            className={`block text-[12px] font-bold ${
                              errors.InquiryOption
                                ? " text-[#E61A05]"
                                : "text-gray-700"
                            }`}
                          >
                            {lang === "en"
                              ? enPhrase["lblBooking"]
                              : arPhrase["lblBooking"]}
                          </label>
                          <Controller
                            name={`inquiryOption-${disclosure.id}`}
                            rules={{
                              required: false,
                            }}
                            control={control}
                            render={({ field }) => (
                              <Select
                                components={{
                                  DropdownIndicator: CustomDropdownIndicator,
                                }}
                                theme={customTheme}
                                styles={customStyles}
                                noOptionsMessage={() =>
                                  lang === "en"
                                    ? enPhrase["lblNoResultFound"]
                                    : arPhrase["lblNoResultFound"]
                                }
                                placeholder={
                                  <div className="text-gray-600 text-sm">
                                    {lang === "en"
                                      ? enPhrase["lblBookingHolder"]
                                      : arPhrase["lblBookingHolder"]}
                                  </div>
                                }
                                label="InquiryOption"
                                error={false}
                                {...field}
                                classNames={{
                                  control: () =>
                                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                                      errors.InquiryOption
                                        ? "!border-red-600"
                                        : "!border-gray-300"
                                    }`,
                                }}
                                classNamePrefix="select"
                                defaultValue={InquiryOptions[0]}
                                isLoading={isLoading}
                                isRtl={isRtl}
                                isSearchable={isSearchable}
                                options={InquiryOptions}
                                getOptionLabel={(options) => options["name"]}
                                getOptionValue={(options) => options["id"]}
                                formatOptionLabel={formatOptionLabel}
                                value={
                                  disclosureData[disclosure.id]
                                    ?.inquiryOption || null
                                }
                                onChange={(selected) => {
                                  field.onChange(selected);
                                  handleInquiryOptionChange(
                                    disclosure.id,
                                    selected
                                  );
                                  clearErrors(`inquiryOption-${disclosure.id}`); // ✅ Clears error
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    {disclosureData[disclosure.id]?.suborderType
                      ?.physicalService === true && (
                      <SharedModal isPhysicalRequest>
                        <div className="md:relative w-full h-full pt-[16px] pb-[8px] md:pt-[0px] md:pb-[0px] ">
                          <div
                            className="w-full flex justify-end"
                            onClick={() => {
                              resetDisclosureFields(disclosure.id);
                            }}
                          >
                            <img
                              src="/assets/img/add-request/closeBorder.svg"
                              alt="close"
                              className={`w-[32px] h-[32px] mx-[16px] md:px-0 md:absolute ${
                                lang === "en"
                                  ? "top-[10px] left-[10px]"
                                  : "top-[16px] left-[16px]"
                              }   flex items-start cursor-pointer`}
                            />
                          </div>
                          <div className="w-full px-[8px] flex flex-col items-center justify-center md:absolute top-[38px] gap-[24px]">
                            <div className="px-[16px] flex flex-col justify-center items-center gap-[8px]">
                              <p className="font-Almarai font-bold text-[16px] md:text-[18px] leading-[28px] text-[#B68A35]">
                                {disclosureData[disclosure.id]?.orderType?.name}
                              </p>
                              <p
                                className={`w-full font-Almarai font-bold text-[18px]  leading-[22px] ${
                                  lang === "en"
                                    ? "md:leading-[30px] md:text-[22px]"
                                    : "md:leading-[36px] md:text-[24px]"
                                } text-[#010202] text-center`}
                              >
                                {lang === "en"
                                  ? enPhrase["lblServiceAvailability"]
                                  : arPhrase["lblServiceAvailability"]}
                              </p>
                            </div>

                            <div className="w-full rounded-[8px] p-[24px] flex flex-col gap-[24px] bg-[#F3F0EA] justify-center items-center">
                              <p>
                                {lang === "en"
                                  ? enPhrase["lblContactCourt"]
                                  : arPhrase["lblContactCourt"]}
                              </p>

                              <div className="w-full flex flex-col md:flex-row items-center gap-[8px]">
                                <div className="w-full md:w-[1/2] rounded-[8px] bg-[#fff] px-[24px] py-[16px] flex flex-col gap-[8px] items-center justify-center">
                                  <img
                                    src="/assets/img/add-request/mail.svg"
                                    alt="e-mail"
                                    className="w-[24px] h-[24px]"
                                  />
                                  <p className="font-Almarai font-normal text-[14px] leading-[24px] text-[#361E12]">
                                    {" "}
                                    {lang === "en"
                                      ? enPhrase["lbl_Email"]
                                      : arPhrase["lbl_Email"]}
                                  </p>
                                  <p className="font-Almarai font-[500] text-[16px] leading-[24px] text-[#B68A35]">
                                    {sharedValues?.court?.courtEmail}
                                  </p>
                                </div>

                                <div className="w-full md:w-[1/2] rounded-[8px] bg-[#fff] px-[24px] py-[16px] flex flex-col gap-[8px] items-center justify-center ">
                                  <img
                                    src="/assets/img/add-request/mobile.svg"
                                    alt="Mobile"
                                    className="w-[24px] h-[24px]"
                                  />
                                  <p className="font-Almarai font-normal text-[14px] leading-[24px] text-[#361E12]">
                                    {lang === "en"
                                      ? enPhrase["lblMobileNumber"]
                                      : arPhrase["lblMobileNumber"]}
                                  </p>
                                  <p
                                    className="font-Almarai font-[500] text-[16px] leading-[24px] text-[#B68A35]"
                                    dir="ltr"
                                  >
                                    {sharedValues?.court?.courtMobileNumber}
                                  </p>
                                </div>
                              </div>

                              <button
                                className="w-full h-[44px] rounded-[4px] border-[1px] border-solid border-[#E9DCC2] bg-[#E9DCC2] flex flex-row items-center justify-center gap-[8px] px-[16px]"
                                onClick={() => {
                                  navigate("/#offices", {
                                    state: { targetId: "offices" },
                                  });
                                }}
                                smooth
                              >
                                <p className="font-Almarai font-normal text-[14px] leading-[20px] text-[##361E12]">
                                  {lang === "en"
                                    ? enPhrase["lblVisitCourtOffices"]
                                    : arPhrase["lblVisitCourtOffices"]}
                                </p>
                                <img
                                  src="/assets/img/add-request/LeftHome.svg"
                                  alt="home"
                                  className={`w-[20px] h-[20px] ${
                                    lang === "en" ? "rotate-90" : ""
                                  }`}
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </SharedModal>
                    )}
                    {disclosureData[disclosure.id]?.suborderType?.toolTip &&
                      !dismissedTooltips[disclosure.id] && (
                        <div className="rounded-[16px] border-[1px] border-solid border-[#E9DCC2] bg-[#fff] py-[12px] px-[16px] flex flex-row items-center justify-between">
                          <div className="flex flex-row items-center gap-[10px]">
                            <img
                              src="/assets/img/add-request/aleart.svg"
                              alt="aleart"
                              className="w-[32px] h-[32px]"
                            />
                            <p
                              className="font-Almarai text-[14px] leading-[20px] text-[#1A1A1A]"
                              dangerouslySetInnerHTML={{
                                __html:
                                  disclosureData[disclosure.id]?.suborderType
                                    ?.toolTip,
                              }}
                            ></p>
                          </div>
                          <img
                            src="/assets/img/add-request/close.svg"
                            alt="close"
                            className="w-[20px] h-[20px] cursor-pointer"
                            onClick={() =>
                              setDismissedTooltips((prev) => ({
                                ...prev,
                                [disclosure.id]: true,
                              }))
                            }
                          />
                        </div>
                      )}

                    {disclosureData[disclosure.id]?.suborderType?.hasNotice &&
                      !dismissedSharesAndBonds[disclosure.id] && (
                        <SharedModal isSharesAndBonds>
                          <SharesAndBonds
                            disclosureData={disclosureData}
                            setDismissedSharesAndBonds={
                              setDismissedSharesAndBonds
                            }
                            disclosure={disclosure}
                            lang={lang}
                            resetDisclosureCustomFields={
                              resetDisclosureCustomFields
                            }
                            setSeperateRequests={setSeperateRequests}
                            closeModal={() =>
                              setDismissedSharesAndBonds((prev) => ({
                                ...prev,
                                [disclosure.id]: true,
                              }))
                            } // ✅ new
                            setDisclosureData={setDisclosureData}
                            ServiceClassificationId={
                              disclosureData[disclosure.id]?.suborderType
                            }
                          />
                        </SharedModal>
                      )}

                    {disclosureData[disclosure.id]?.orderType?.id === 1 && (
                      <AddLocation
                        errors={errors}
                        lang={lang}
                        arPhrase={arPhrase}
                        enPhrase={enPhrase}
                        setSharedValues={setSharedValues}
                        clearErrors={clearErrors}
                        register={register}
                        sharedValues={sharedValues}
                        setDisclosureData={setDisclosureData}
                        disclosureData={disclosureData}
                        disclosure={disclosure}
                        setShowMap={setShowMap}
                        handleLocationSelect={handleLocationSelect}
                        openMapForDisclosure={openMapForDisclosure}
                        setValue={setValue}
                        getValues={getValues}
                        setError={setError}
                      />
                    )}

                    <div className="cursor-pointer flex flex-col">
                      <Controller
                        name={`fileupload-${disclosure.id}`} // Unique name for each disclosure
                        control={control}
                        rules={{
                          required:
                            lang === "en"
                              ? enPhrase["lblUploadError"]
                              : arPhrase["lblUploadError"], // Validation rule
                        }}
                        render={({ field }) => (
                          <div className="cursor-pointer flex flex-col">
                            {/* File Label */}
                            <label
                              htmlFor={`fileupload-${disclosure.id}`}
                              className={`block text-[12px]  mb-[5px] ${
                                errors[`fileupload-${disclosure.id}`]
                                  ? "text-[#E61A05] font-normal"
                                  : "text-gray-700 font-bold"
                              }`}
                            >
                              {lang === "en"
                                ? enPhrase["lblJudgedecision"]
                                : arPhrase["lblJudgedecision"]}
                            </label>

                            {/* Upload Box */}
                            {disclosureData[disclosure.id]?.fileUpload ? (
                              <div className="bg-[#fff] rounded-[8px] border-[1px] border-solid border-[#D4D2CE] p-[16px] flex flex-col gap-[12px] md:gap-0 md:flex-row items-center justify-between">
                                <div className="w-full flex flex-row items-center  gap-[16px]">
                                  <img
                                    src="/assets/img/add-request/File-JPG.svg"
                                    alt="JPG"
                                    className="w-[32px] h-[32px]"
                                  />
                                  <div className="flex flex-col items-start justify-center ">
                                    <p className="font-Almarai font-bold text-[12px] md:text-[14px] leading-[20px] text-[#0E0D0C] max-w-[190px] md:max-w-[233px] truncate">
                                      {disclosureData[disclosure.id]?.fileName}
                                    </p>
                                    <p
                                      className="font-Almarai font-normal text-[12px] leading-[20px] text-[#6F6A62]"
                                      dir="ltr"
                                    >
                                      {(
                                        disclosureData[disclosure.id]
                                          ?.fileSize /
                                        (1024 * 1024)
                                      ).toFixed(2)}{" "}
                                      MB
                                    </p>
                                  </div>
                                </div>

                                <div className="flex flex-row items-center gap-[12px]">
                                  <button
                                    className="w-[112.5px] md:w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#B68A35] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent form validation

                                      const file =
                                        disclosureData[disclosure.id]
                                          ?.selectedUploadFile;
                                      const hash =
                                        disclosureData[disclosure.id]
                                          ?.fileUpload;
                                      const url =
                                        disclosureData[disclosure.id]
                                          ?.displayedImage;
                                      const fileName =
                                        disclosureData[disclosure.id]
                                          ?.fileName || "";

                                      if (!hash || !url || !file) return;

                                      const isPDF =
                                        file?.type
                                          ?.toLowerCase()
                                          ?.includes("pdf") ||
                                        fileName.toLowerCase().endsWith(".pdf");

                                      if (isPDF && isMobileDevice()) {
                                        window.open(url, "_blank");
                                      } else {
                                        setDisplayedImage(url);
                                        setPreviewDisclosureId(disclosure.id); // 👈 Set the current disclosure ID
                                        setShowImage(true);
                                      }
                                    }}
                                  >
                                    <img
                                      src="/assets/img/add-request/Show.svg"
                                      alt="show"
                                      className="w-[20px] h-[20px]"
                                    />
                                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12] flex md:hidden">
                                      {lang === "en"
                                        ? enPhrase["lblShow"]
                                        : arPhrase["lblShow"]}
                                    </p>
                                  </button>

                                  <button
                                    className="w-[112.5px] md:w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#E23636] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
                                    onClick={() => {
                                      setDisclosureData((prevData) => ({
                                        ...prevData,
                                        [disclosure.id]: {
                                          ...prevData[disclosure.id],
                                          fileUpload: null, // Remove file
                                        },
                                      }));
                                      setValue(
                                        `fileupload-${disclosure.id}`,
                                        null
                                      ); // Clear value from react-hook-form
                                      setDisplayedImage(null); // Remove displayed image
                                      setShowImage(false); // Hide image preview
                                    }}
                                  >
                                    <img
                                      src="/assets/img/add-request/Trash.svg"
                                      alt="delete"
                                      className="w-[20px] h-[20px]"
                                    />
                                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#E23636] flex md:hidden">
                                      {lang === "en"
                                        ? enPhrase["lblDelete"]
                                        : arPhrase["lblDelete"]}
                                    </p>
                                  </button>
                                </div>
                                {showImage && displayedImage && (
                                  <SharedModal
                                    showImage
                                    setOpenModal={setShowImage}
                                    openModal={showImage}
                                  >
                                    <div className="w-full rounded-t-[16px]">
                                      <div className="h-[56px] w-full flex items-center justify-end px-[24px] bg-[#eee2d0]">
                                        <img
                                          src="/assets/img/close.svg"
                                          alt=""
                                          className="cursor-pointer"
                                          onClick={() => setShowImage(false)}
                                        />
                                      </div>

                                      {(() => {
                                        const previewFile =
                                          disclosureData[previewDisclosureId]
                                            ?.selectedUploadFile;
                                        const fileName =
                                          disclosureData[previewDisclosureId]
                                            ?.fileName || "";

                                        const isPDF =
                                          previewFile?.type
                                            ?.toLowerCase()
                                            ?.includes("pdf") ||
                                          fileName
                                            .toLowerCase()
                                            .endsWith(".pdf");

                                        return isPDF ? (
                                          <iframe
                                            src={displayedImage}
                                            className="w-full h-[288px] rounded-b-[16px]"
                                            type="application/pdf"
                                            title="PDF Preview"
                                          />
                                        ) : (
                                          <img
                                            src={displayedImage}
                                            alt="Preview"
                                            className="w-full h-[288px] rounded-b-[16px]"
                                          />
                                        );
                                      })()}
                                    </div>
                                  </SharedModal>
                                )}
                              </div>
                            ) : (
                              <label
                                htmlFor={`fileupload-${disclosure.id}`}
                                className="relative cursor-pointer flex flex-col w-[100%] items-center justify-center h-[123px] border-2 border-dashed bg-[#fff] border-[#B4B4B4] rounded-md px-6 pt-[46px] pb-[45px] font-medium text-gold-100"
                              >
                                {/* Upload Icon & Message */}
                                {!disclosureData[disclosure.id]?.fileUpload &&
                                !uploadingDisclosures[disclosure.id] ? (
                                  <div className="flex items-center gap-[4px] flex-col">
                                    <img
                                      src="/assets/img/add-request/UploadFile.svg"
                                      alt="Upload-File"
                                      className="w-[32px] h-[32px]"
                                    />
                                    <p className="text-[14px] text-[#0E0D0C] font-bold text-center">
                                      {lang === "en"
                                        ? enPhrase["lblAttachJudgeDecision"]
                                        : arPhrase["lblAttachJudgeDecision"]}
                                    </p>

                                    <p className="text-[12px] text-[#B68A35] font-normal text-center w-full md:w-[140px]">
                                      {lang === "en"
                                        ? enPhrase["lblValidationInputDocument"]
                                        : arPhrase[
                                            "lblValidationInputDocument"
                                          ]}
                                    </p>
                                  </div>
                                ) : (
                                  <Loader
                                    color={"mainColor"}
                                    imageSrc="/assets/img/add-request/LogoIcon.svg"
                                    isRequest
                                    isUpload={true}
                                    circleThickness={1} // Outer circle thickness
                                    pathThickness={1} // Path thickness (spinner line)
                                  />
                                )}

                                {/* Hidden File Input */}
                                <input
                                  id={`fileupload-${disclosure.id}`}
                                  type="file"
                                  accept="image/png, image/jpeg, application/pdf, image/jpg"
                                  className="sr-only"
                                  onChange={(e) => {
                                    handleFileChange(disclosure.id, e);
                                    field.onChange(e.target.files[0]);
                                  }}
                                  onClick={(e) => {
                                    e.target.value = null; // **Reset input field to allow re-selection**
                                  }}
                                />

                                {/* Show Uploaded File Name */}
                                {disclosureData[disclosure.id]?.fileUpload && (
                                  <span role="alert" className="text-xs">
                                    {
                                      disclosureData[disclosure.id].fileUpload
                                        .name
                                    }
                                  </span>
                                )}
                              </label>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    {/* File Upload Error Message */}
                    {errors[`fileupload-${disclosure.id}`] && (
                      <span
                        role="alert"
                        className="text-red-600  text-xs mb-[10px]"
                      >
                        {errors[`fileupload-${disclosure.id}`]?.message}
                      </span>
                    )}

                    <Controller
                      name={`fileidentificationupload-${disclosure.id}`}
                      control={control}
                      rules={{
                        validate: (files) => {
                          if (!files || files.length === 0) {
                            return lang === "en"
                              ? enPhrase["lblValidationIdentificationError"]
                              : arPhrase["lblValidationIdentificationError"];
                          }
                          if (files.length > 7) {
                            return lang === "en"
                              ? "You can upload up to 7 files only"
                              : "يمكنك تحميل 7 ملفات كحد أقصى";
                          }
                          for (let file of files) {
                            if (
                              ![
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ].includes(file.type)
                            ) {
                              return lang === "en"
                                ? enPhrase["lblOnlyImgAndPDF"]
                                : arPhrase["lblOnlyImgAndPDF"];
                            }
                            if (file.size > 10 * 1024 * 1024) {
                              // 5MB max
                              return lang === "en"
                                ? enPhrase["lblRestrictedSize"]
                                : arPhrase["lblRestrictedSize"];
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <div className="cursor-pointer flex flex-col mt-[8px]">
                          <label
                            htmlFor={`fileidentificationupload-${disclosure.id}`}
                            className={`block text-[12px] mb-[5px] ${
                              errors[
                                `fileidentificationupload-${disclosure.id}`
                              ]
                                ? "text-red-600 font-normal"
                                : "text-gray-700 font-bold"
                            }`}
                          >
                            {lang === "en"
                              ? enPhrase["lblIdentificationDocHead"]
                              : arPhrase["lblIdentificationDocHead"]}
                          </label>
                          <p
                            className={`font-Almarai text-[12px] mb-[5px] leading-[20px] font-400 cursor-default ${
                              disclosureData[disclosure.id]
                                ?.fileIdentificationUpload?.length === 7
                                ? "text-red-600"
                                : "text-[#6F6A62]"
                            }`}
                          >
                            {lang === "en"
                              ? enPhrase["lblValidationIdentificationTxt"]
                              : arPhrase["lblValidationIdentificationTxt"]}
                          </p>
                          <label
                            htmlFor={`fileidentificationupload-${disclosure.id}`}
                            className={`relative cursor-pointer flex flex-col w-[100%] items-center justify-center h-[123px] border-2 border-dashed bg-[#fff] border-[#B4B4B4] rounded-md px-6 pt-[46px] pb-[45px] font-medium text-gold-100 ${
                              disclosureData[disclosure.id]
                                ?.fileIdentificationUpload?.length === 7
                                ? "hidden"
                                : "block"
                            } `}
                          >
                            {uploadingIdentification[disclosure.id] ? (
                              <Loader
                                color={"mainColor"}
                                imageSrc="/assets/img/add-request/LogoIcon.svg"
                                isRequest
                                isUpload={true}
                                circleThickness={1} // Outer circle thickness
                                pathThickness={1} // Path thickness (spinner line)
                              />
                            ) : (
                              <div className="flex items-center gap-[4px] flex-col">
                                <img
                                  src="/assets/img/add-request/UploadFile.svg"
                                  alt="Upload-File"
                                  className="w-[32px] h-[32px]"
                                />
                                <p className="text-[14px] leading-[20px] text-[#0E0D0C] font-bold text-center">
                                  {lang === "en"
                                    ? enPhrase[
                                        "lblIdentificationDocPlaceHolder"
                                      ]
                                    : arPhrase[
                                        "lblIdentificationDocPlaceHolder"
                                      ]}
                                </p>
                                <p className="text-[12px] text-[#B68A35] font-normal text-center w-full md:w-[140px]">
                                  {lang === "en"
                                    ? enPhrase["lblValidationInputDocument"]
                                    : arPhrase["lblValidationInputDocument"]}
                                </p>
                              </div>
                            )}

                            <input
                              id={`fileidentificationupload-${disclosure.id}`}
                              type="file"
                              accept="image/png, image/jpeg, application/pdf, image/jpg"
                              className="sr-only"
                              multiple
                              // disabled={
                              //   (disclosureData[disclosure.id]
                              //     ?.fileIdentificationUpload?.length || 0) >= 7
                              // }
                              disabled={
                                uploadingIdentification[disclosure.id] ||
                                (disclosureData[disclosure.id]
                                  ?.fileIdentificationUpload?.length || 0) >= 7
                              }
                              onChange={(e) => {
                                const newFiles = Array.from(e.target.files);
                                const MAX_SIZE_MB = 10;
                                const validTypes = [
                                  "image/png",
                                  "image/jpeg",
                                  "application/pdf",
                                  "image/jpg",
                                ];

                                const invalidFiles = newFiles.filter(
                                  (file) =>
                                    !validTypes.includes(file.type) ||
                                    file.size > MAX_SIZE_MB * 1024 * 1024
                                );

                                if (invalidFiles.length > 0) {
                                  // Show the first error found
                                  const firstInvalid = invalidFiles[0];
                                  const msg = !validTypes.includes(
                                    firstInvalid.type
                                  )
                                    ? lang === "en"
                                      ? enPhrase["lblOnlyImgAndPDF"]
                                      : arPhrase["lblOnlyImgAndPDF"]
                                    : lang === "en"
                                    ? enPhrase["lblRestrictedSize"]
                                    : arPhrase["lblRestrictedSize"];

                                  setError(
                                    `fileidentificationupload-${disclosure.id}`,
                                    {
                                      type: "manual",
                                      message: msg,
                                    }
                                  );
                                  return;
                                }

                                // If all valid, continue
                                clearErrors(
                                  `fileidentificationupload-${disclosure.id}`
                                );

                                handleIdentificationUpload(
                                  disclosure.id,
                                  newFiles,
                                  field
                                );

                                // const existingFiles =
                                //   disclosureData[disclosure.id]?.fileIdentificationUpload || [];
                                // const mergedFiles = [...existingFiles, ...newFiles].slice(0, 7);

                                // field.onChange(mergedFiles);
                                // setDisclosureData((prevData) => ({
                                //   ...prevData,
                                //   [disclosure.id]: {
                                //     ...prevData[disclosure.id],
                                //     fileIdentificationUpload: mergedFiles,
                                //   },
                                // }));

                                e.target.value = "";
                              }}
                            />
                          </label>

                          {errors[
                            `fileidentificationupload-${disclosure.id}`
                          ] && (
                            <span
                              role="alert"
                              className="text-red-600 text-xs mt-[5px]"
                            >
                              {
                                errors[
                                  `fileidentificationupload-${disclosure.id}`
                                ]?.message
                              }
                            </span>
                          )}

                          {/* Display selected files */}
                          {disclosureData[disclosure.id]
                            ?.fileIdentificationUpload &&
                            disclosureData[
                              disclosure.id
                            ]?.fileIdentificationUpload.map((file, idx) => (
                              <div
                                key={idx}
                                className="bg-[#fff] mt-[12px] rounded-[8px] border-[1px] border-solid border-[#D4D2CE] p-[16px] flex flex-col gap-[12px] md:gap-0 md:flex-row items-center justify-between"
                              >
                                <div className="w-full flex flex-row items-center  gap-[16px]">
                                  <img
                                    src="/assets/img/add-request/File-JPG.svg"
                                    alt="JPG"
                                    className="w-[32px] h-[32px]"
                                  />
                                  <div className="flex flex-col items-start justify-center ">
                                    <p className="font-Almarai font-bold text-[12px] md:text-[14px] leading-[20px] text-[#0E0D0C] max-w-[190px] md:max-w-[233px] truncate">
                                      {file?.name}
                                    </p>
                                    <p
                                      className="font-Almarai font-normal text-[12px] leading-[20px] text-[#6F6A62]"
                                      dir="ltr"
                                    >
                                      {(file?.size / (1024 * 1024)).toFixed(2)}{" "}
                                      MB
                                    </p>
                                  </div>
                                </div>

                                <div className="flex flex-row items-center gap-[12px]">
                                  <button
                                    className="w-[112.5px] md:w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#B68A35] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent form validation

                                      const selectedFile = file; // from map (already available)
                                      const fileUrl =
                                        URL.createObjectURL(selectedFile);

                                      const isPDF =
                                        selectedFile?.type
                                          ?.toLowerCase()
                                          .includes("pdf") ||
                                        selectedFile?.name
                                          .toLowerCase()
                                          .endsWith(".pdf");

                                      if (isPDF && isMobileDevice()) {
                                        window.open(fileUrl, "_blank");
                                      } else {
                                        setDisplayedImage(fileUrl);
                                        setPreviewDisclosureId(disclosure.id);
                                        setShowImage(true);
                                      }
                                    }}
                                  >
                                    <img
                                      src="/assets/img/add-request/Show.svg"
                                      alt="show"
                                      className="w-[20px] h-[20px]"
                                    />
                                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12] flex md:hidden">
                                      {lang === "en"
                                        ? enPhrase["lblShow"]
                                        : arPhrase["lblShow"]}
                                    </p>
                                  </button>

                                  <button
                                    className="w-[112.5px] md:w-[40px] h-[40px] rounded-[4px] border-[1px] border-solid border-[#E23636] bg-[#fff] flex items-center justify-center gap-[8px] md:gap-0"
                                    // onClick={() => {
                                    //   setDisclosureData((prevData) => {
                                    //     const updatedFiles = prevData[
                                    //       disclosure.id
                                    //     ]?.fileIdentificationUpload.filter(
                                    //       (_, i) => i !== idx
                                    //     );
                                    //     return {
                                    //       ...prevData,
                                    //       [disclosure.id]: {
                                    //         ...prevData[disclosure.id],
                                    //         fileIdentificationUpload:
                                    //           updatedFiles,
                                    //       },
                                    //     };
                                    //   });
                                    //   field.onChange(
                                    //     disclosureData[
                                    //       disclosure.id
                                    //     ]?.fileIdentificationUpload.filter(
                                    //       (_, i) => i !== idx
                                    //     )
                                    //   );
                                    // }}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent form validation
                                      setDisclosureData((prevData) => {
                                        const updated = { ...prevData };
                                        const currentDisclosure =
                                          updated[disclosure.id];

                                        const updatedFiles =
                                          currentDisclosure.fileIdentificationUpload.filter(
                                            (_, i) => i !== idx
                                          );

                                        // ✅ Remove the hash at the same index
                                        const updatedSubjectDocs =
                                          currentDisclosure.SubjectDocuments?.filter(
                                            (_, i) => i !== idx
                                          ) || [];

                                        updated[disclosure.id] = {
                                          ...currentDisclosure,
                                          fileIdentificationUpload:
                                            updatedFiles,
                                          SubjectDocuments: updatedSubjectDocs,
                                        };

                                        // ✅ Handle clone as well
                                        const cloneId = `${disclosure.id}-copy`;
                                        if (updated[cloneId]) {
                                          const updatedCloneFiles = (
                                            updated[cloneId]
                                              .fileIdentificationUpload || []
                                          ).filter((_, i) => i !== idx);

                                          const updatedCloneSubjectDocs = (
                                            updated[cloneId].SubjectDocuments ||
                                            []
                                          ).filter((_, i) => i !== idx);

                                          updated[cloneId] = {
                                            ...updated[cloneId],
                                            fileIdentificationUpload:
                                              updatedCloneFiles,
                                            SubjectDocuments:
                                              updatedCloneSubjectDocs,
                                          };
                                        }

                                        return updated;
                                      });

                                      // ✅ Update React Hook Form field
                                      field.onChange(
                                        disclosureData[
                                          disclosure.id
                                        ]?.fileIdentificationUpload.filter(
                                          (_, i) => i !== idx
                                        )
                                      );
                                    }}
                                  >
                                    <img
                                      src="/assets/img/add-request/Trash.svg"
                                      alt="delete"
                                      className="w-[20px] h-[20px]"
                                    />
                                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#E23636] flex md:hidden">
                                      {lang === "en"
                                        ? enPhrase["lblDelete"]
                                        : arPhrase["lblDelete"]}
                                    </p>
                                  </button>
                                </div>
                                {showImage && displayedImage && (
                                  <SharedModal
                                    showImage
                                    setOpenModal={setShowImage}
                                    openModal={showImage}
                                  >
                                    <div className="w-full rounded-t-[16px]">
                                      <div className="h-[56px] w-full flex items-center justify-end px-[24px] bg-[#eee2d0]">
                                        <img
                                          src="/assets/img/close.svg"
                                          alt=""
                                          className="cursor-pointer"
                                          onClick={() => setShowImage(false)}
                                        />
                                      </div>

                                      {(() => {
                                        const isPDF =
                                          file?.type
                                            ?.toLowerCase()
                                            ?.includes("pdf") ||
                                          file?.name
                                            .toLowerCase()
                                            .endsWith(".pdf");

                                        return isPDF ? (
                                          <iframe
                                            src={displayedImage}
                                            className="w-full h-[288px] rounded-b-[16px]"
                                            type="application/pdf"
                                            title="PDF Preview"
                                          />
                                        ) : (
                                          <img
                                            src={displayedImage}
                                            alt="Preview"
                                            className="w-full h-[288px] rounded-b-[16px]"
                                          />
                                        );
                                      })()}
                                    </div>
                                  </SharedModal>
                                )}
                              </div>
                            ))}
                        </div>
                      )}
                    />

                    {(disclosureData[disclosure.id]?.fileIdentificationUpload
                      ?.length || 0) >= 7 && (
                      <p className="text-xs text-red-600 mt-1">
                        {lang === "en"
                          ? enPhrase["lblMaxDocuments"]
                          : arPhrase["lblMaxDocuments"]}
                      </p>
                    )}

                    <div className="flex items-center justify-start gap-[16px]">
                      <img
                        src="/assets/img/add-request/WarningCircle.svg"
                        alt="Warning"
                        className="w-[20px] h-[20px]"
                      />
                      <p className="font-Almarai font-bold text-[12px] leading-[20px] text-[#010202]">
                        {lang === "en"
                          ? enPhrase["lblDocumentEntity"]
                          : arPhrase["lblDocumentEntity"]}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Disclosure.Panel>
          </div>
        );
      }}
    </Disclosure>
  );
};

export default DisclosureSection;
